import { Component, OnInit } from '@angular/core';
import { Product } from '../../shared/models/product';
import { DataService } from '../../service/data.service';
import { SORT } from '../../shared/Constant/constant';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { CouponDialogComponent } from '../../coupon-dialog/coupon-dialog.component'; 
import { UserService } from '../../service/UserService'; 

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit {

  maxCreateAt: string | undefined;
  createAtPlus5BusinessDays: string | undefined;
  createAtPlus20BusinessDays: string | undefined;

  public productList: any[] = [];
  public isLoading: boolean = false;
  public rangeResult: number = 0;
  public filterData: any[] = [];
  totalProducts: number = 0;
  public currentPage: number = 1;
  itemsPerPage: number = 10;
  public istoggelGridListView = 'grid';
  public searchKey!: string;

  public isSearching: boolean = false; // 💡 Nueva bandera de estado de búsqueda

  randomNumber: any;
  public selectedCategory: string = 'All Products';

  constructor(
    private data: DataService,
    private dialog: MatDialog,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    const storedMaxCreateAt = sessionStorage.getItem('maxCreateAt');
    const storedCreateAtPlus5 = sessionStorage.getItem('createAtPlus5BusinessDays');
    const storedCreateAtPlus20 = sessionStorage.getItem('createAtPlus20BusinessDays');

    if (storedMaxCreateAt && storedCreateAtPlus5 && storedCreateAtPlus20) {
      this.maxCreateAt = storedMaxCreateAt;
      this.createAtPlus5BusinessDays = storedCreateAtPlus5;
      this.createAtPlus20BusinessDays = storedCreateAtPlus20;
    } else {
      this.fetchOrderDates();
    }

    this.getAllProduct();
    this.getSearchedValue();
    
    // 💡 Llama al método para verificar si se debe abrir el diálogo AHORA.
    this.checkAndOpenCouponDialog();
  }

  // 💡 Mueve esta función a este componente
  checkAndOpenCouponDialog(): void {
    const token = localStorage.getItem('token');
    
    if (!token) {
      this.openCouponDialog();
    }
  }

  // 💡 Mueve esta función a este componente
  async openCouponDialog(): Promise<void> {
    const couponId = 'NEW-CLIENT';
    try {
      const couponData = await this.userService.getPromoCodeById(couponId).toPromise();
  
      this.dialog.open(CouponDialogComponent, {
        width: '450px',
        data: {
          title: couponData.title,
          message: couponData.description,
          urlImage: couponData.urlImage, 
          code: couponData.code
        }
      });
    } catch (error) {
      console.error('Error al obtener los datos del cupón:', error);
      this.dialog.open(CouponDialogComponent, {
        width: '450px',
        data: {
          title: '¡Bienvenido!',
          message: 'Regístrate',
          imageUrl: '-',
          code: '-'
        }
      });
    }
  }

  getAllProduct(): void {
    this.isLoading = true;
    this.data.getAllProductList().subscribe((res: Product[]) => {
      this.productList = res;
      this.filterData = this.productList;
      this.isLoading = false;
      this.getMaxPrice();
      this.applyFilters();
    });
  }

  fetchOrderDates(): void {
    this.data.getMaxDatesOrder().subscribe(
      (data) => {
        this.maxCreateAt = data.maxCreateAt;
        this.createAtPlus5BusinessDays = data.createAtPlus5BusinessDays;
        this.createAtPlus20BusinessDays = data.createAtPlus20BusinessDays;
        if (this.maxCreateAt) {
          sessionStorage.setItem('maxCreateAt', this.maxCreateAt);
        }
        if (this.createAtPlus5BusinessDays) {
          sessionStorage.setItem('createAtPlus5BusinessDays', this.createAtPlus5BusinessDays);
        }
        if (this.createAtPlus20BusinessDays) {
          sessionStorage.setItem('createAtPlus20BusinessDays', this.createAtPlus20BusinessDays);
        }
      },
      (error) => {
        console.error('Error:', error);
      }
    );
  }

  getSearchedValue() {
    this.data.search.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe((val: any) => {
      this.isSearching = true;
      this.searchKey = val;
      this.currentPage = 1;
      this.applyFilters();
      setTimeout(() => {
        this.isSearching = false;
      }, 500);
    });
  }

  getMaxPrice(): number {
    return this.rangeResult = Math.max(...this.productList.map((o: Product) => o.priceShop));
  }

  addToCart(productId: String): void {
    this.generateRandomNumber();
    let addToCart = this.productList.filter((item: Product) => {
      return item.id === productId;
    });
    this.data.addProductToCart(addToCart[0]);
  }

  generateRandomNumber(): number {
    const randomNumberA = Math.floor(100000 + Math.random() * 900000);
    this.randomNumber = randomNumberA;
    return randomNumberA;
  }

  sortProduct(event: any): Product[] {
    switch (event.target.value) {
      case SORT.Low_price: {
        this.sortByLowToHigh();
        break;
      }
      case SORT.High_price: {
        this.sortByHighToLow();
        break;
      }
      case SORT.Name: {
        this.sortByName();
        break;
      }
      default: {
        this.sortByLowToHigh();
        break;
      }
    }
    return this.productList;
  }

  sortByLowToHigh(): Product[] {
    return this.productList = this.productList.sort((low: any, high: any) => {
      return low.priceShop - high.priceShop;
    });
  }

  sortByHighToLow(): Product[] {
    return this.productList = this.productList.sort((low: any, high: any) => {
      return high.priceShop - low.priceShop;
    });
  }

  sortByName(): Product[] {
    return this.productList.sort((low: any, high: any) =>
      low.product.localeCompare(high.product)
    );
  }

  rangeChange(event: Event): void {
    this.currentPage = 1;
    this.applyFilters();
  }

  getCategory(event: { category: string, count: number }): void {
    this.selectedCategory = event.category;
    this.currentPage = 1;
    this.applyFilters();
  }

  getMinMaxPrice(event: Event): void {
    this.currentPage = 1;
    this.applyFilters();
  }

  toggelGridListView(mode: string) {
    this.istoggelGridListView = mode;
  }

  applyFilters() {
    this.currentPage = 1;
    let filteredProducts = this.filterData ? [...this.filterData] : [];
    if (this.searchKey) {
      filteredProducts = filteredProducts.filter(product =>
        product.product.toLowerCase().includes(this.searchKey.toLowerCase())
      );
    }
    if (this.selectedCategory !== 'All Products') {
      filteredProducts = filteredProducts.filter(product =>
        product.category === this.selectedCategory
      );
    }
    this.totalProducts = filteredProducts.length;
    this.productList = filteredProducts;
  }

  paginate(filteredProducts: Product[]): Product[] {
    const offset = (this.currentPage - 1) * this.itemsPerPage;
    return filteredProducts.slice(offset, offset + this.itemsPerPage);
  }
}
